import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"location\"><path fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16m0-2A6 6 0 1 0 8 1.999 6 6 0 0 0 8 14M6.008 3.017 4.025 4.488l.486 3.48 1.497 1.089 1.013-3.061 1.009-.002 1.585-1.499-1.965-1.87zm.014 7.968.996-.97 2.007-.027L11.54 8.25l1.263 1.465L11.496 12l-2.469 1.016-1.625-.468z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol